import { render, staticRenderFns } from "./VolumeReportTemplate.vue?vue&type=template&id=bf5bedbe"
import script from "./VolumeReportTemplate.vue?vue&type=script&lang=js"
export * from "./VolumeReportTemplate.vue?vue&type=script&lang=js"
import style0 from "./VolumeReportTemplate.vue?vue&type=style&index=0&id=bf5bedbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports